import { asText } from '@prismicio/richtext';
import { Footnotes } from 'components/footnotes/Footnotes';
import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';
import { H2 } from 'components/heading/Heading';
import { RichText } from 'components/rich-text/RichText';
import { PageSlicesTitle_And_Text } from 'prismic-types';
import { PrismicRichText } from 'prismic/types/richtext';

export type TitleAndTextSlice = PageSlicesTitle_And_Text;

type Props = {
  title?: PrismicRichText;
  text?: PrismicRichText;
  footnotes?: PrismicRichText;
};

export const TitleAndTextSlice = ({
  title,
  text,
  footnotes,
}: Props): JSX.Element => {
  return (
    <GridLayout>
      <GridLayoutItem columns={{ desktop: 5 }} offset={{ desktop: 1 }}>
        {title && (
          <>
            <H2>{asText(title)}</H2>
            <br />
          </>
        )}
      </GridLayoutItem>
      <GridLayoutItem columns={{ desktop: 5, tablet: 8 }}>
        <div>
          {text && <RichText>{text}</RichText>}
          {footnotes && <Footnotes footnotes={footnotes} />}
        </div>
      </GridLayoutItem>
    </GridLayout>
  );
};

export function prismicSliceToTitleAndText(s: TitleAndTextSlice) {
  return (
    <TitleAndTextSlice
      title={s.variation?.primary?.title}
      text={s.variation?.primary?.text}
      footnotes={s.variation?.primary?.footnotes}
    />
  );
}
